module.exports = __webpack_public_path__ + "img/feature-card1.ae088c3c.png";